import { render, staticRenderFns } from "./CreateClass.vue?vue&type=template&id=2da30a6e&"
import script from "./CreateClass.vue?vue&type=script&lang=ts&"
export * from "./CreateClass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports